import './Spinner.styled.scss'

export const Spinner = () => (
  <div className="spinnerWrapper">
    <span className="spinner" data-testid="spinner" />
  </div>
)
